import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, ContainerLoading } from '~components';
import Icon, { faCheckCircle } from '~components/icon';
import { UserFeedback } from '~main/components';
import SummaryStatCard from '~support-at-home/components/claims/common/SummaryStatCard';

import { Claim } from '~support-at-home/models';

import { useCreateClaimMutation } from '~support-at-home/actions/claims';

interface ComponentProps {
  value: {
    start_date: string;
    end_date: string;
    naps_id?: string[];
    status_id?: string[];
  };
}

const ClaimDetailsNew: React.FC<ComponentProps> = ({ value }) => {
  const { start_date, end_date, naps_id, status_id } = value;
  const navigate = useNavigate();

  const [claim, setClaim] = useState<Claim | null>(null);
  const [loaded, setLoaded] = useState(false);

  const [createClaim, { isLoading }] = useCreateClaimMutation();

  useEffect(() => {
    if (loaded) return;
    create();
  }, [start_date, end_date, naps_id, status_id, loaded]);

  const create = async () => {
    try {
      const { data: payload } = await createClaim({ start_date, end_date, naps_id, status_id });
      const { claim } = payload ?? {};
      if (!claim) return;

      setClaim(claim);
      setLoaded(true);
    } catch (error) {
      console.warn('error on create', error);
    }
  };

  const handleNavigateToClaim = () => {
    if (claim?.id) {
      navigate(`/support-at-home/claims/${claim.id}`);
    }
  };

  return (
    <ContainerLoading loading={isLoading} bgColor="white" color="black" isTransparent={true}>
      {claim && (
        <div className="d-flex flex-column align-items-center py-5">
          <div className="text-center mb-4">
            <div className="mb-3">
              <Icon icon={faCheckCircle} size="4x" className="text-success" />
            </div>
            <h3 className="fw-bold text-success mb-2">Claim Created Successfully!</h3>
            <p className="text-muted">Reference: {claim.reference}</p>
          </div>

          <div className="row w-100 mb-4 gap-3 justify-content-center">
            <div className="col-md-2">
              <SummaryStatCard count={claim.items_count ?? 0} countLabel="Total Items" />
            </div>
            <div className="col-md-2">
              <SummaryStatCard count={claim.items_valid ?? 0} countLabel="Valid Items" countClassName="text-success" />
            </div>
            <div className="col-md-2">
              <SummaryStatCard
                count={claim.items_with_errors ?? 0}
                countLabel="Items with Errors"
                countClassName="text-danger"
              />
            </div>
            <div className="col-md-2">
              <SummaryStatCard count={claim.items_ignored ?? 0} countLabel="Ignored Items" />
            </div>
          </div>

          <Button className={'text-white'} color="success" size="lg" onClick={handleNavigateToClaim}>
            View Claim
          </Button>
        </div>
      )}
      <UserFeedback workflowType="sah-claims-wizard" isVisible={!isLoading && !!claim} />
    </ContainerLoading>
  );
};

export default ClaimDetailsNew;
